module.exports = __webpack_public_path__ + "static/media/phone.421367bc.png";